import { memo, useCallback } from 'react';
import ReactDOM from 'react-dom/client';
import { EntityTypes } from '@wg/wows-entities/const';
import WoWSEntity from '@wg/wows-entities/wrappers/react/WoWSEntity';

import { t } from '~/helpers/localization';
import { CURRENCY_DESCRIPTION } from '~/i18nStrings';

import styles from './ClanWallet.module.scss';

interface ClanWalletProps {
  clanResource: number;
  accumulativeResource: number;
}

const ClanWallet = ({ clanResource, accumulativeResource }: ClanWalletProps) => {
  const amount = clanResource;
  const totalAmount = accumulativeResource;

  const afterHeaderTooltipSlot = useCallback(
    (node: HTMLElement) => {
      ReactDOM.createRoot(node).render(
        <div>
          {t('В наличии:')}&nbsp;
          <span style={{ display: 'inline-block' }}>
            <WoWSEntity
              type={EntityTypes.CURRENCY}
              id={'clan_resource'}
              amount={amount}
              presentation={{
                withTooltip: false,
                renderWithoutFade: true,
              }}
            />
          </span>
          <br />
          {t('Всего получено:')}&nbsp;
          <span style={{ display: 'inline-block' }}>
            <WoWSEntity
              type={EntityTypes.CURRENCY}
              id={'clan_resource'}
              amount={totalAmount}
              presentation={{
                withTooltip: false,
                renderWithoutFade: true,
              }}
            />
          </span>
        </div>,
      );
    },
    [amount, totalAmount],
  );

  const beforeFooterTooltipSlot = useCallback((node: HTMLElement) => {
    ReactDOM.createRoot(node).render(
      CURRENCY_DESCRIPTION['clan_resource'].split('\n').map((line, idx, arr) => (
        <div key={`clan_resource_line_${idx}`}>
          {line}
          {idx < arr.length - 1 && <br />}
        </div>
      )),
    );
  }, []);

  return (
    <WoWSEntity
      key={`we_oil_${amount}_${totalAmount}`}
      type={EntityTypes.CURRENCY}
      id={'clan_resource'}
      className={styles.wallet}
      amount={amount}
      presentation={{
        withTooltip: true,
        hideTooltipAmount: true,
        hideReceiveText: true,
        hideSpendText: true,
      }}
      customisation={{
        afterHeaderTooltipSlot,
        beforeFooterTooltipSlot,
      }}
    />
  );
};

export default memo(ClanWallet);
